import type {
  IAssetTemplateAssignedModalType,
  IAssetTemplateModalData,
} from '../modules/modal-pick-template/types';

import { useCallback, useState } from 'react';

export interface IAssetTemplateModalAssignedResult {
  isOpenModalAssigned: boolean;
  modalAssignedData?: IAssetTemplateModalData;
  modalAssignedType?: IAssetTemplateAssignedModalType;
  handleCloseModalAssigned: () => void;
  handleSetModalAssignedType: (value: IAssetTemplateAssignedModalType) => void;
  handleSetModalAssignedData: (value: IAssetTemplateModalData) => void;
}

export const useInitializeAssetTemplateModalAssigned = (): IAssetTemplateModalAssignedResult => {
  const [modalAssignedType, setModalAssignedType] = useState<
    IAssetTemplateAssignedModalType | undefined
  >(undefined);
  const [modalAssignedData, setModalAssignedData] = useState<IAssetTemplateModalData | undefined>(
    undefined,
  );

  const handleSetModalAssignedType = useCallback(
    (value: IAssetTemplateAssignedModalType) => setModalAssignedType(value),
    [],
  );
  const handleSetModalAssignedData = useCallback(
    (value: IAssetTemplateModalData) => setModalAssignedData(value),
    [],
  );
  const handleCloseModalAssigned = useCallback(() => {
    setModalAssignedType(undefined);
    setModalAssignedData(undefined);
  }, []);

  return {
    modalAssignedData,
    modalAssignedType,
    isOpenModalAssigned: !!modalAssignedType,
    handleCloseModalAssigned,
    handleSetModalAssignedType,
    handleSetModalAssignedData,
  };
};
